import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { AllRecruitmentResponseModel, RecruitmentResponseModel } from '@gtpl/shared-models/masters';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { Injectable } from '@nestjs/common';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { Raw } from 'typeorm';
import { RecruitmentAdapter } from './dto/recruitment-adpater';
import { RecruitmentDTO } from './dto/recruitment-dto';
import { RecruitmentRequest } from './dto/recruitment-request';
import { RecruitmentRepository } from './recruitment-repository';
import { Recruitment } from './recruitment.entity';

@Injectable()
export class RecruitmentService {

    constructor(
      private logService:LogsService,

        private recruitmentRepository: RecruitmentRepository,
        private recruitmentAdapter: RecruitmentAdapter
    ) { }


    async createRecruitment(recruitmentDto: RecruitmentDTO, isUpdate: boolean): Promise<RecruitmentResponseModel> {

        try {
            // to check whether State exists with the passed  State code or not. if isUpdate is false, a check will be done whether a record with the passed Statecode is existing or not. if a record exists then a return message wil be send with out saving the data.  if record is not existing with the passed State code then a new record will be created. if isUpdate is true, then no check will be performed and  record will be updated(if record exists with the passed cluster code) or created.
            if (!isUpdate) {
                const recruitmentEntity = await this.getRecruitmentDetailsWithoutRelations(recruitmentDto.recruitmentMode);
                if (recruitmentEntity) {
                    //return new InformationMessageError(11104, "State already exists");
                    throw new ErrorResponse(11104, 'Recruitment already exists');
                }
            }
            else {
                const recruitmentEntity = await this.getRecruitmentDetailsWithoutRelations(recruitmentDto.recruitmentMode);
                if (recruitmentEntity) {
                    if (recruitmentEntity.recruitmentId != recruitmentDto.recruitmentId) {
                        throw new ErrorResponse(11104, 'Recruitment already exists');
                    }
                }
            }
            const convertedRecruitmentEntity: Recruitment = this.recruitmentAdapter.convertDtoToEntity(recruitmentDto, isUpdate);
            const savedRecruitmentEntity: Recruitment = await this.recruitmentRepository.save(
                convertedRecruitmentEntity
            );
            const savedRecruitmentDto: RecruitmentDTO = this.recruitmentAdapter.convertEntityToDto(convertedRecruitmentEntity);

            if (savedRecruitmentDto) {

                const response = new RecruitmentResponseModel(true, 1, isUpdate ? 'Recruitment Updated Successfully' : 'Recruitment Created Successfully');
                const name=isUpdate?'updated':'created'
            
                const newLogDto = new LogsDto(1,name, 'Recruitment', savedRecruitmentDto.recruitmentId, true, '',savedRecruitmentDto.createdUser)
                let res = await this.logService.createLog(newLogDto);
                console.log(res);
                return response
            } else {

                throw new ErrorResponse(11106, 'Recruitment saved but issue while transforming into DTO');
            }
        } catch (error) {

            throw error;
        }
    }

    async getRecruitmentDetailsWithoutRelations(recruitmentMode: string): Promise<Recruitment> {
        // tslint:disable-next-line: typedef
        const recruitmentResponse = await this.recruitmentRepository.findOne({
            where: { recruitmentId: Raw(alias => `recruitment_mode = '${recruitmentMode}'`) },
        });
        if (recruitmentResponse) {
            return recruitmentResponse;
        } else {
            return null;
        }
    }

    async getAllRecruitment(): Promise<AllRecruitmentResponseModel> {

        try {
            const RecruitmentDtos: RecruitmentDTO[] = [];

            const recruitmentEntities: Recruitment[] = await this.recruitmentRepository.find({ order: { 'recruitmentMode': 'ASC' } });

            if (recruitmentEntities) {

                recruitmentEntities.forEach(RecruitmentEntity => {
                    const convertedRecruitmentDto: RecruitmentDTO = this.recruitmentAdapter.convertEntityToDto(
                        RecruitmentEntity
                    );
                    RecruitmentDtos.push(convertedRecruitmentDto);
                });
                const response = new AllRecruitmentResponseModel(true, 1, 'Recruitment retrieved successfully', RecruitmentDtos);
                const newLogDto = new LogsDto(1,'view', 'Recruitment', 0, true, '','')
                let res = await this.logService.createLog(newLogDto);
                console.log(res);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data not found');
            }

        } catch (err) {
            throw err;
        }
    }
    async getRecruitmentById(recruitmentId: number): Promise<Recruitment> {

        const Response = await this.recruitmentRepository.findOne({
            where: { recruitmentId: recruitmentId },
        });

        if (Response) {
            return Response;
        } else {
            return null;
        }
    }

    async activateOrDeactivateRecruitment(recruitmentReq: RecruitmentRequest): Promise<RecruitmentResponseModel> {
        try {
            const recruitmentExists = await this.getRecruitmentById(recruitmentReq.recruitmentId);
            if (recruitmentExists) {
                if (recruitmentReq.versionFlag !== recruitmentExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the recruitment information.Refresh and try again');
                } else {

                    const recruitmentStatus = await this.recruitmentRepository.update(
                        { recruitmentId: recruitmentReq.recruitmentId },
                        { isActive: recruitmentReq.isActive, updatedUser: recruitmentReq.updatedUser });

                    if (recruitmentExists.isActive) {
                        if (recruitmentStatus.affected) {
                            const recruitmentResponse: RecruitmentResponseModel = new RecruitmentResponseModel(true, 10115, 'Recruitment is de-activated successfully');
                            return recruitmentResponse;
                        } else {
                            throw new ErrorResponse(10111, 'Recruitment is already deactivated');
                        }
                    } else {
                        if (recruitmentStatus.affected) {
                            const RecruitmentResponse: RecruitmentResponseModel = new RecruitmentResponseModel(true, 10114, 'Recruitment is activated successfully');
                            return RecruitmentResponse;
                        } else {
                            throw new ErrorResponse(10112, 'Recruitment is already  activated');
                        }
                    }

                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }

    async getAllActiveRecruitment(): Promise<AllRecruitmentResponseModel> {

        try {
            const RecruitmentDtos: RecruitmentDTO[] = [];

            const recruitmentEntities: Recruitment[] = await this.recruitmentRepository.find({
                order: { 'recruitmentMode': 'ASC' }, where: { isActive: true },
            });
            console.log(recruitmentEntities)
            if (recruitmentEntities) {

                recruitmentEntities.forEach(countriesEntity => {
                    const convertedRecruitmentDtos: RecruitmentDTO = this.recruitmentAdapter.convertEntityToDto(
                        countriesEntity
                    );
                    RecruitmentDtos.push(convertedRecruitmentDtos);
                });
                const response = new AllRecruitmentResponseModel(true, 11108, "Recruitment retrieved successfully", RecruitmentDtos);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data not found'); RecruitmentDtos
            }
        } catch (err) {
            throw err;
        }
    }

    async getActiveCurrencyById(recruitmentReq: RecruitmentRequest): Promise<RecruitmentResponseModel> {
        try {
            //retrieves all companies
            const recruitmentEntities: Recruitment = await this.recruitmentRepository.findOne({
              where:{recruitmentId:recruitmentReq.recruitmentId}
              });
              
              const recruitmentData: RecruitmentDTO = this.recruitmentAdapter.convertEntityToDto(recruitmentEntities);
              if (recruitmentData) {
                  const response = new RecruitmentResponseModel(true, 11101 , 'Recruitment retrived Successfully',recruitmentData);
                  return response;
              }
              else{
                  throw new ErrorResponse(11106,'Something went wrong');
              }
              // generating resposnse
        } catch (err) {
            throw err;
        }
    }



}
